import { RestContentType, RestResponse } from "../cutil/RestClient";
import { ErrorUtil } from "../api/ErrorUtil";
import { eventbus } from "../cutil/Eventbus";
import { UnauthorizedMsg } from "../msg/UnauthorizedMsg";
import isBlank from "@sedan-utils/is-blank";
export class FotClientAdapter {
    constructor(baseUrl, authStore, projectStore) {
        this.baseUrl = baseUrl;
        this.authStore = authStore;
        this.projectStore = projectStore;
    }
    errorHandler(error) {
        if (error instanceof RestResponse) {
            // 提前注入错误处理函数，会被 API 的 parseError 重写
            error.parseError(res => {
                const errorFromApi = ErrorUtil.parseRestResponse(res);
                return errorFromApi || ErrorUtil.defaultErrorMsg;
            });
            if (error.status === 401) {
                this.authStore.logout();
                eventbus.emit(new UnauthorizedMsg());
            }
        }
    }
    get headers() {
        const brainToken = this.authStore.state.brainToken;
        const guestToken = this.authStore.state.guestToken;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let header = {
            "X-Brain-User-Tz": tz,
        };
        if (!isBlank(brainToken)) {
            header["Authorization"] = `token ${brainToken}`;
        }
        const attrIndexer = this.projectStore.attrIndexer;
        if (!isBlank(attrIndexer)) {
            header["X-Brain-Imagica-Id"] = attrIndexer;
        }
        return header;
    }
    get contentType() {
        return RestContentType.json;
    }
    isCustomApiType(headers) {
        return false;
    }
}
